export const USER_EXPIRED = 'redux-oidc/USER_EXPIRED';
export const REDIRECT_SUCCESS = 'redux-oidc/REDIRECT_SUCCESS';
export const USER_LOADED = 'redux-oidc/USER_LOADED';
export const SILENT_RENEW_ERROR = 'redux-oidc/SILENT_RENEW_ERROR';
export const SILENT_RENEW_STARTED = 'redux-oidc/SILENT_RENEW_STARTED';
export const SESSION_TERMINATED = 'redux-oidc/SESSION_TERMINATED';
export const USER_EXPIRING = 'redux-oidc/USER_EXPIRING';
export const USER_FOUND = 'redux-oidc/USER_FOUND';
export const USER_NOT_FOUND = 'redux-oidc/USER_NOT_FOUND';
export const LOADING_USER = 'redux-oidc/LOADING_USER';
export const USER_SIGNED_OUT = 'redux-oidc/USER_SIGNED_OUT';
export const LOAD_USER_ERROR = 'redux-oidc/LOAD_USER_ERROR';
